import { Backdrop, CircularProgress, DialogProps } from '@material-ui/core';
import React from 'react';

import { DialogBase } from './DialogBase';

const IN_PANEL_DIALOG_PROPS: Partial<DialogProps> = {
  disableEscapeKeyDown: true,
  disablePortal: true,
  fullWidth: true,
  maxWidth: 'sm',
  style: { position: 'absolute' },
  BackdropProps: {
    style: {
      position: 'absolute',
    },
  },
};

interface ActionDialogProps {
  open: boolean;
  title: React.ReactNode;
  loading: boolean;
  children: React.ReactNode;
}

export const ActionDialog: React.FC<ActionDialogProps> = ({ open, title, loading, children }) => (
  <DialogBase open={open} title={title} DialogProps={IN_PANEL_DIALOG_PROPS} actions={null}>
    <div style={{ position: 'relative', width: '100%' }}>
      {children}

      <Backdrop
        open={loading}
        style={{
          position: 'absolute',
          zIndex: 1000,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
        }}
      >
        <CircularProgress />
      </Backdrop>
    </div>
  </DialogBase>
);
